import { LatLngExpression } from 'leaflet';
import { ReactElement } from 'react';
import { BodyConfig, ObjectBeams } from '@dmc/ui';
import { BeamsSVGLayer } from '../beams-svg-layer/BeamsSVGLayer';
import { BasicBeamData } from '@customer/store/apis/investigationsApi';
import { BeamDataFactory } from '@customer/store/apis/BeamDataFactory';

// Allow the body config to be optional since different beams have different requirements (arc doesn't need body config to display).
export interface BeamsLayerProps extends Partial<BodyConfig> {
  position: LatLngExpression;
  heading: number | null;
  beamData: BasicBeamData;
}

/**
 * The beam representation in this layer is unique to a specific point on the timeline.
 * There is no need for memoisation within the component.
 */
export const BeamsLayer = ({
  position,
  heading,
  bodyWidth = 0,
  bodyLength = 0,
  yRotOfs = 0,
  beamData,
}: BeamsLayerProps): ReactElement | null => {
  // Only continue if there is at least enough data to render one type of beam (arc).
  if (beamData.InteractionState !== null) {
    const beamsParams = BeamDataFactory.getBeamsParams(beamData);
    const hasHeading = typeof heading === 'number' && beamData.HeadingValid === true;
    const safeHeading = heading ?? 0;

    return (
      <ObjectBeams bodyWidth={bodyWidth} bodyLength={bodyLength} yRotOfs={yRotOfs}>
        <BeamsSVGLayer position={position} beamsParams={beamsParams}>
          <ObjectBeams.GroupTransform heading={safeHeading}>
            <ObjectBeams.AllBeams
              hasHeading={hasHeading}
              beamsParams={beamsParams}
              interactionState={beamData.InteractionState}
            />
          </ObjectBeams.GroupTransform>
        </BeamsSVGLayer>
      </ObjectBeams>
    );
  } else {
    return null;
  }
};
